import React from "react";
import { connect } from "react-redux";
import * as R from "ramda";
import moment from "moment";

import ImageComponent from "./ImageComponent";
import * as s from "./selector";
import * as t from "./thunk";
import * as a from "./action";

import { DataTable } from "../DataComponents";

import { bindActionCreators } from "redux";

const componentTransformer = R.compose(
  connect(
    (state, props) => ({
      ...state.cards2,
      shouldDisplay: s.shouldDisplay(state),
      cardInfo: s.cardInfo(state),
    }),
    (dispatch) => bindActionCreators({ ...a, ...t }, dispatch)
  )
);

class CardsTable extends React.Component {
  async componentDidMount() {
    await this.props.fetchCards();
  }

  componentWillUnmount() {
    this.props.clearCards();
  }

  render() {
    return (
      <div>
        <ImageComponent
          onClose={this.props.closeImage}
          cardInfo={this.props.cardInfo}
          isOpen={this.props.shouldDisplay}
        />
        <DataTable
          dataName="Cards"
          data={this.props.cards}
          columns={this.columns}
          dataTransformer={this.dataTransformer}
        />
      </div>
    );
  }

  dataTransformer = (card) => {
    const {
      deductions,
      enteredValue,
      faceValue: faceValueStr,
      merchantName,
      number,
      type,
      refID,
      internalId,
      id,
      paymentStatus,
      sellPercentage: sellPercentageStr,
      order: {
        orderId: orderID,
        date: orderDate,
        status: orderStatus,
        orderInCompletedStatus,
      },
    } = card;

    // NOTE: I don't like this code.
    let balance = 0.0;
    let sellPercentage = 0.0;
    try {
      let faceValue = parseFloat(faceValueStr);
      sellPercentage = parseFloat(sellPercentageStr);
      // we should only use entered value until the order has been processed
      balance =
        faceValue === 0.0 && !orderInCompletedStatus ? enteredValue : faceValue;
    } catch (error) {
      balance = enteredValue;
    }

    let payout = balance * (sellPercentage / 100);
    let orderStatusAcronym = orderStatus
      .toLowerCase()
      .split(/\s+/)
      .reduce((a, s) => [...a, s[0]], [])
      .join(".")
      .toUpperCase();

    let deductedText = "";
    if (deductions && deductions.length > 0) {
      deductedText = " & Deducted";
    }

    return {
      balance: "$" + balance,
      cardId: internalId,
      brand: merchantName,
      number,
      orderDate: moment(orderDate).format("MM/DD/YYYY"),
      orderID,
      orderStatus: orderStatus + deductedText,
      cardPmtStatus:
        +faceValueStr === 0 && orderInCompletedStatus
          ? "N/A"
          : paymentStatus + deductedText,
      payout: "$" + payout.toFixed(2),
      sellPercentage: card.sellPercentage + "%",
      refID,
      type,
      uuid: id,
      image: "<em>VIEW</em>",
      raw: card,
      tips: {
        orderStatus,
      },
    };
  };

  get columns() {
    return [
      { label: "Brand", dataKey: "brand" },
      { label: "Card #", dataKey: "number", numeric: true },
      { label: "Ref ID", dataKey: "refID" },
      { label: "Balance", dataKey: "balance", numeric: true },
      { label: "Payout", dataKey: "payout", numeric: true },
      { label: "Sell Percentage", dataKey: "sellPercentage" },
      { label: "Order Date", dataKey: "orderDate", numeric: true },
      { label: "Status", dataKey: "cardPmtStatus" },
      { label: "OrderID", dataKey: "orderID", numeric: true },
      { label: "Card ID", dataKey: "cardId", numeric: true },
      { label: "Type", dataKey: "type" },
      {
        label: "Image",
        dataKey: "image",
        numeric: true,
        link: true,
        props: { onClick: this.viewCardImageHandler },
      },
    ];
  }

  viewCardImageHandler = (event, { rowData }) => {
    this.props.fetchCardImage(rowData.uuid);
  };
}

CardsTable = componentTransformer(CardsTable);

export { CardsTable };
